import React, { useState } from 'react';
import { ethers } from 'ethers';
import './App.css';

function App() {
  const [walletConnected, setWalletConnected] = useState(false);
  const [balance, setBalance] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const connectWallet = async () => {
    if (window.ethereum) {
      setLoading(true);
      setError('');
      try {
        const provider = new ethers.BrowserProvider(window.ethereum);
        await provider.send("eth_requestAccounts", []);

        const accounts = await provider.listAccounts();
        if (accounts.length === 0) {
          throw new Error("No accounts found.");
        }

        const address = accounts[0];
        setWalletConnected(true);

        const balance = await provider.getBalance(address);
        setBalance(ethers.formatEther(balance));
      } catch (error) {
        setError("Error connecting.");
        console.error("Error connecting :", error);
      } finally {
        setLoading(false);
      }
    } else {
      alert('Please install MetaMask!');
    }
  };

  return (
    <div className="app-container">
      <h1>Crypto Wallet Connection</h1>
      {!walletConnected ? (
        <button className="connect-button" onClick={connectWallet} disabled={loading}>
          {loading ? 'Connecting...' : 'Connect Wallet'}
        </button>
      ) : (
        <div className="wallet-info">
          <p className="status">Wallet Connected!</p>
          <p className="balance">Balance: {balance} ETH</p>
        </div>
      )}
      {error && <p className="error-message">{error}</p>}
    </div>
  );
}

export default App;
